
export const TARGET_REVIEW_VOTING_NUM = 6;
